import { GET_DIGITAL_OFFERS, GET_DIGITAL_OFFERS_SUCCESS, GET_DIGITAL_OFFERS_ERROR, GET_DIGITAL_OFFERS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDigitalOffers = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIGITAL_OFFERS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_OFFERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_OFFERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DIGITAL_OFFERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDigitalOffers;
